import { MutationTree } from "vuex";
import {
  S,
  ReleaseNotesMutations,
  ReleaseNotesMutationNames
} from "@tt-app/types/releaseNotes/store";

const releaseNotesMutations: MutationTree<S> & ReleaseNotesMutations = {
  [ReleaseNotesMutationNames.RELEASE_NOTES](state, paginatedReleaseNotes) {
    state.paginatedReleaseNotes = paginatedReleaseNotes;
  },
  [ReleaseNotesMutationNames.SET_LOADING](state, isLoading: boolean) {
    state.loading = isLoading;
  }
};

export { releaseNotesMutations };
